
























































































import { Component, Vue } from 'vue-property-decorator';
import {
  getUserInfo,
  getVerificationCode,
  setNewPassword,
  sendVoiceMessage
} from '@/api/info';
import path from 'path';
import { basePath } from '@/utils/index';
import xiaoButton from '@/components/button/index.vue';
import { validatePassword } from '@/utils';
import { INcOptions } from '@/api/interface';

declare const noCaptcha: any;

@Component({
  name: 'Forget',
  components: {
    xiaoButton
  }
})

export default class Forget extends Vue {
  hasGetCode = false;
  passwordReadOnly = true;
  ncOptions!: INcOptions;
  formData = {
    phone: '',
    verificationCode: '',
    password: '',
    confirmPassword: ''
  };
  goBack() {
    this.$router.go(-1);
  }
  async getVerificationCode() {
    /*if (!this.ncOptions) {
      return this.$message.error('请先完成验证码验证');
    }*/
    if (this.formData.phone.length !== 11) {
      return this.$message.error('请输入合法的手机号码');
    }
    const params = {
      phone: this.formData.phone/*,
      nc_validate: this.ncOptions*/
    };
    const { success, msg } = await getVerificationCode(params);
    if (success) {
      this.$message.success('短信验证码发送成功，请查收。');
      this.hasGetCode = true;
    } else {
      this.$message.error(msg);
    }
  }

  private async submit() {
    const isVaild = this.validate();
    if (isVaild) {
      const { phone, verificationCode, password } = this.formData;
      const { success, msg } = await setNewPassword({
        phone,
        code: verificationCode,
        password
      });
      if (success) {
        this.$message.success('你的密码已设置成功，请重新登录');
        setTimeout(() => {
          const { next = '' } = this.$route.query as any;
          window.location.href = path.join(`${basePath}/user`, next);
        }, 1000);
      } else {
        this.$message.error(msg);
      }
    }
  }

  private validate() {
    const { password, confirmPassword } = this.formData;
    if (!validatePassword(password)) {
      this.$message.error('密码必须是大写+小写+数字+符号的组合，且长度不少于8位');
      return false;
    }
    if (password !== confirmPassword) {
      this.$message.error('您两次输入的密码不一致！请检查后重试！');
      return false;
    }
    return true;
  }
  // 发送语音验证码
  async sentVoiceMessage() {
    const { success, msg } = await sendVoiceMessage();
    if (success) {
      this.$message.success('语音验证码发送成功，请注意收听');
    } else {
      this.$message.error(msg);
    }
  }
  initAliyunNC() {
    const nc = new noCaptcha(); // eslint-disable-line new-cap
    const appkey = 'FFFF000000000176CAD2';
    const scene = 'login';
    const token = [appkey, (new Date()).getTime(), Math.random()].join(':');
    const ncOption = {
      renderTo: '#aliyun-nc-captcha',
      appkey,
      scene,
      token,
      callback: (data: any) => { // 校验成功回调
        this.ncOptions = {
          csessionid: data.csessionid,
          sig: data.sig,
          token,
          scene
        };
      }
    };
    nc.init(ncOption);
  }
  limitPasswordLength() {
    const { password } = this.formData;
    if (password.length > 64) {
      this.formData.password = password.slice(0, 64);
      this.$message.warning('您输入的密码过长，请检查后重试');
    }
  }
  async mounted() {
    // this.initAliyunNC();
  }
}
